export const types = {
  SET_RELEASES: "SET_RELEASES",
  ADD_RELEASE: "ADD_RELEASE",
};

export const setReleases = payload => ({
  type: types.SET_RELEASES,
  payload,
});

export const addRelease = payload => ({
  type: types.ADD_RELEASE,
  payload,
});
